import { Select } from 'antd';
import React, { useEffect } from 'react';
import { useGetClinicOwners } from '../../hooks/clinic/useGetClinicOwners';

const ClinicOwnersFormItem = (props) => {
  const { data, getClinicOwners, loading } = useGetClinicOwners();
  useEffect(() => {
    getClinicOwners();
  }, []);

  return (
    <Select showSearch loading={loading} placeholder="Select" allowClear options={data} {...props}/>
  );
};

export default ClinicOwnersFormItem;
